import { Package } from '@features/DynamicPackagesConfigurationWizard/types';

export type PackageInclusion = 'room' | 'spa' | 'dining';

const hasSpaExperience = (packageData: Package) =>
  !!packageData.experiences?.some((experience) =>
    experience.options?.some((option) => option.itemType !== 'spa-extras')
  );

export const getPackageInclusions = (packageData?: Package | null): PackageInclusion[] => {
  if (!packageData) return [];

  const inclusions: PackageInclusion[] = [];

  if (hasSpaExperience(packageData)) inclusions.push('spa');
  if (packageData.restaurants?.length) inclusions.push('dining');

  return inclusions.length > 0 ? ['room', ...inclusions] : [];
};
